export default __webpack_public_path__ + "static/KlaviyoCertificate-3589c65994e4626c0039293b78fe0a7c.png";